import React from "react";
import { View, Text, TextInput } from "ui";
import { Memo, Alert } from "types";
import moment from "moment";
import { DATE_FORMAT } from "../shared/constants";
import { styled } from "styles";
import { Link } from "react-router-dom";

interface P {
  alert?: Alert;
  expired?: boolean;
  memo?: Memo;
  onClick?: (alert: Alert) => void;
}

const AlertItem: React.SFC<P> = ({ memo, alert, expired, onClick }) => {
  return (
    <AlertBody
      key={alert.id}
      m={1}
      bg={expired ? "warning" : "primary"}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      p={1}
      borderRadius={10}
      as={Link}
      to={`/app/alerts/${alert.id}`}
    >
      <View
        bg="white"
        m={1}
        borderRadius={10}
        alignSelf="stretch"
        alignItems="center"
        justifyContent="center"
      >
        <Text py={[1, 2]} px={2} color="black" fontSize={3} fontWeight="bold">
          {moment(alert.end_date, DATE_FORMAT).format("DD")}
        </Text>
      </View>
      <View ml={2} flex={10} flexDirection="column" alignItems="stretch">
        <Text color="white" fontSize={4} fontWeight="bold">
          {alert.name}
        </Text>
        <Text color="white" fontSize={2}>
          {memo.name}
        </Text>
      </View>
    </AlertBody>
  );
};

const AlertBody = styled(View)`
  cursor: pointer;
  text-decoration: none;
  max-height: 60px;
` as any;

export default AlertItem;



// WEBPACK FOOTER //
// ./src/components/AlertItem.tsx